import { Component, inject, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { FormBuilder, FormGroup, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import {
  MAT_DIALOG_DATA,
  MatDialogRef,
  MatDialogClose,
  MatDialogTitle,
  MatDialogContent,
  MatDialogActions,
} from '@angular/material/dialog';
import { MatButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { CdkScrollable } from '@angular/cdk/scrolling';
import { MatFormField, MatError } from '@angular/material/form-field';
import { MatInput } from '@angular/material/input';
import { UpperCasePipe, TitleCasePipe } from '@angular/common';
import { L10nTranslatePipe } from 'angular-l10n';
@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'miq-export-limits-dialog',
  templateUrl: './export-limits-dialog.component.html',
  styleUrl: './export-limits-dialog.component.scss',
  imports: [
    MatButton,
    MatDialogClose,
    MatIcon,
    MatDialogTitle,
    CdkScrollable,
    MatDialogContent,
    FormsModule,
    ReactiveFormsModule,
    MatFormField,
    MatInput,
    MatError,
    MatDialogActions,
    UpperCasePipe,
    TitleCasePipe,
    L10nTranslatePipe
],
})
export class ExportLimitsDialogComponent implements OnInit {
  public exportLimitsFormGroup: FormGroup;
  public dialogRef = inject(MatDialogRef<ExportLimitsDialogComponent>);
  private readonly data = inject(MAT_DIALOG_DATA);
  private readonly formBuilder = inject(FormBuilder);
  ngOnInit() {
    this.exportLimitsFormGroup = this.formBuilder.group({
      availability: [this.data.availability || '', Validators.required],
      lease: [this.data.lease || '', Validators.required],
      sale: [this.data.sale || '', Validators.required],
      portfoliosale: [this.data.portfoliosale || '', Validators.required],
      property: [this.data.property || '', Validators.required],
      tim: [this.data.tim || '', Validators.required],
      company: [this.data.company || '', Validators.required],
      contact: [this.data.contact || '', Validators.required],
      tenancy: [this.data.tenancy || '', Validators.required],
      brand: [this.data.brand || '', Validators.required],
      space: [this.data.space || '', Validators.required],
      activity: [this.data.activity || '', Validators.required],
    });
  }
  public submitChange() {
    this.dialogRef.close(this.exportLimitsFormGroup.value);
  }
  public closeDialog() {
    this.dialogRef.close();
  }
  // form controls getters
  public get availability() {
    return this.exportLimitsFormGroup.get('availability');
  }
  public get lease() {
    return this.exportLimitsFormGroup.get('lease');
  }
  public get sale() {
    return this.exportLimitsFormGroup.get('sale');
  }
  public get portfoliosale() {
    return this.exportLimitsFormGroup.get('portfoliosale');
  }
  public get property() {
    return this.exportLimitsFormGroup.get('property');
  }
  public get tim() {
    return this.exportLimitsFormGroup.get('tim');
  }
  public get company() {
    return this.exportLimitsFormGroup.get('company');
  }
  public get contact() {
    return this.exportLimitsFormGroup.get('contact');
  }
  public get tenancy() {
    return this.exportLimitsFormGroup.get('tenancy');
  }
  public get brand() {
    return this.exportLimitsFormGroup.get('brand');
  }
  public get space() {
    return this.exportLimitsFormGroup.get('space');
  }
  public get activity() {
    return this.exportLimitsFormGroup.get('activity');
  }
}
